export default "__VITE_ASSET__B_mGJi5j__"